import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useBrand } from "../brand/BrandContext";

const HERO_IMAGE = "/images/bus-background.jpg";

/**
 * Герой-блок головної: бренд + заголовок. Пошук — у формі під hero.
 */
const HeroSection = ({ title, subtitle, imageUrl, height = 380 }) => {
  const { t } = useTranslation("common");
  const brand = useBrand();
  const heroTitle =
    title !== undefined && title !== null
      ? title
      : brand.homepage?.hero_title || t("hero.title");
  const heroSubtitle =
    subtitle !== undefined && subtitle !== null
      ? subtitle
      : brand.homepage?.hero_subtitle || t("hero.subtitle");
  const backgroundImage =
    imageUrl ||
    brand.homepage?.blocks?.find((b) => b.type === "hero")?.props?.image_url ||
    HERO_IMAGE;
  return (
    <Box
      sx={{
        marginTop: "calc(-1 * var(--header-height, 72px))",
        paddingTop: "var(--header-height, 72px)",
        height: { xs: 340, sm: height },
        minHeight: { xs: 300, sm: 300 },
        alignItems: { xs: "flex-start", sm: "center" },
        backgroundImage: `url('${backgroundImage}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.45)",
        },
      }}
      aria-label={t("hero.bannerLabel")}
    >
      <Box sx={{ position: "relative", zIndex: 1, px: 2, pt: { xs: 2.5, sm: 0 }, maxWidth: 900 }}>
        <Typography
          variant="overline"
          sx={{
            color: "rgba(255,255,255,0.95)",
            fontWeight: 700,
            letterSpacing: "0.12em",
            fontSize: { xs: "0.75rem", sm: "0.85rem" },
            mb: 0.5,
            display: "block",
          }}
        >
          {brand.name}
        </Typography>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: "white",
            fontWeight: 700,
            fontSize: { xs: "1.45rem", sm: "1.85rem", md: "2.15rem" },
            lineHeight: 1.25,
            mb: 1,
          }}
        >
          {heroTitle}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "rgba(255,255,255,0.92)",
            fontSize: { xs: "0.85rem", sm: "1rem" },
            lineHeight: 1.45,
            maxWidth: 720,
            mx: "auto",
          }}
        >
          {heroSubtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSection;
